export const CASH = 'cash';
export const TRANSFER_KEIMAHNI = 'transfer-keimahni';
export const TRANSFER_DAWR = 'transfer-dawr';

// Cannot keep extra fields here as the file is used
// to populate dropdowns
